 async function updateCartFormVisibility(target = 'modal'){
  const res = await fetch('/cart.js');
  const cart = await res.json();
  // 追加した商品の配送時期とカート内の配送時期を比較し、配送時期の異なる商品がある場合はhasDifferentをtrueにする
  const shippingSchedules = cart.items.map(item => item.properties?.['配送時期']).filter(Boolean);
  const uniqueSchedules = [...new Set(shippingSchedules)];
  const hasDifferent = uniqueSchedules.length > 1;
  // ボタン要素
  const formEl = document.querySelector('.cart__form');
  // 同意チェック要素
  const checkEl = document.querySelector('.cart__agree-checkbox');
  // 購入不可アラート要素
  const ctasEl = document.querySelector('.cart__ctas');
  if (formEl && checkEl && ctasEl) {
    if (hasDifferent) {
      formEl.style.display = target == 'modal' ?  'grid' : 'none';
      checkEl.style.display = 'none';
      ctasEl.style.display = 'grid';
    } else {
      formEl.style.display = target == 'modal' ? 'grid' : 'block';
      checkEl.style.display = 'grid';
      ctasEl.style.display = 'none';
    }
  }
}
window.updateCartFormVisibility = updateCartFormVisibility;